import MediaSyncManagementReducer from 'store/media-sync-management/reducers';

export default MediaSyncManagementReducer;
